/**
 * This method is responsible for stopping all tracks of a given MediaStream object, disposing it completely.
 *
 * @example
 * ```
 * disposeMediaStream(streamObj);
 * ```
 *
 * @param mediaStream - The MediaStream object to be disposed;
 */
function disposeMediaStream(mediaStream) {
    mediaStream.getTracks().forEach((track) => track.stop());
}
export { disposeMediaStream, };
//# sourceMappingURL=barcode-utils.js.map